import type { DifficultyVariant } from '@components/fixtures/v2/constants';

/**
 * Dark card palette carried over from the social image cards so an article
 * card matches what readers already see on the club's socials. Bands come from
 * the shared `ratingToDifficulty`, so an article and the fixture ticker page
 * never disagree about how hard a fixture is.
 */
export const DARK_DIFFICULTY_COLOUR_CLASSES: Record<DifficultyVariant, string> =
  {
    'very-easy': 'bg-[#26472E]',
    easy: 'bg-[#427B50]',
    moderate: 'bg-[#8F4F19]',
    hard: 'bg-[#8A4242]',
    'very-hard': 'bg-[#562B2A]'
  };

export const BLANK_GAMEWEEK_COLOUR_CLASS = 'bg-[#2C3134]';
